<template>
  <main class="container my-5">

    <div class="page-container">

      <div
        v-if="loading"
        class="text-center py-5"
      >

        <div
          class="spinner-border
                 text-primary"
        ></div>

      </div>

      <template v-else>

        <div
          v-if="book"
        >

          <span
            class="text-primary
                   fw-semibold"
          >
            INVENTORY
          </span>

          <h2 class="fw-bold">
            Edit Book
          </h2>

          <p class="text-muted">
            Update the book information.
          </p>

          <BookForm
            :initial-book="book"
            submit-text="Update Book"
            @submit="updateBook"
          />

        </div>

        <div
          v-else
          class="alert alert-danger"
        >
          Book not found.
        </div>

      </template>

    </div>

  </main>
</template>

<script>
import BookForm
  from '../components/BookForm/BookForm.vue'

export default {
  name: 'EditBook',

  components: {
    BookForm
  },

  data() {
    return {
      book: null,
      loading: true
    }
  },

  async mounted() {
    try {
      const id =
        this.$route.params.id

      const books =
        this.$store.state.books

      this.book =
        books.find(
          book =>
            String(book.id) ===
            String(id)
        )

    } finally {
      this.loading = false
    }
  },

  methods: {
    async updateBook(
      updatedBook
    ) {
      const result =
        await this.$store.dispatch(
          'updateBook',
          updatedBook
        )

      if (!result.success) {
        alert(
          result.message
        )

        return
      }

      alert(
        'Book updated successfully!'
      )

      this.$router.push(
        '/books'
      )
    }
  }
}
</script>

<style scoped>
.page-container {
  max-width: 850px;

  margin: auto;

  background: white;

  padding: 35px;

  border-radius: 18px;

  box-shadow:
    0 5px 25px
    rgba(0, 0, 0, 0.06);
}
</style>